var lx = lx || {};
lx.commentOld = lx.commentOld || {};
/* Comments created by Davor on 02.08.2019 
 * lx.comment.init({recId: 4231, etyId: 38});
 * lx.comment.init({htmlID: "commentRegionID",recId: 4231, etyId: 38});
 * lx.comment.init({htmlID: this.id, extractOptions: true});
 */ 
lx.comment = {
    loc: { // Temporary solution.. until we get global js translations solution
        INTERNAL_CMT_LABEL: apex.lang.getMessage("ADMIN_COMMENTS"), /*"Admin Comments",*/
        SHARED_CMT_LABEL: apex.lang.getMessage("SHARED_COMMENTS"), /*"Comments",*/
		SHARED_CMT_PH: apex.lang.getMessage("ENTER_COMMENT"), /*"Enter a comment",*/
        UPDATES: apex.lang.getMessage("UPDATES_COMMENTS"), /*"Updates",*/
        POST: apex.lang.getMessage("POST"), /*"Post"*/
        BOOKMARK: 'Likes/Bookmark',
    },
    data: {},
    options: {},
    page: 1,
    $cont: null,
    placeholders: {},
    init: function(pOptions) {
        this.page = $v("pFlowStepId");
        if (pOptions.extractOptions) {
            this.setOptions(pOptions.htmlID);
            this.data.row = [];
            this.options.fetch = 1;
            this.$cont.attr("data-fetch","1");
            /*this.options.tabOpen = (this.options.tabOpen == 'first' || typeof this.options.tabOpen == "undefined" ?
                                (this.data.shared   == 1 ? 'Shared' :
                                (this.data.internal == 1 ? 'Internal' : 
                                (this.data.updates  == 1 ? 'Updates' : this.options.tabOpen))) : this.options.tabOpen);
            this.$cont.attr("data-tabopen", this.options.tabOpen);*/
            this.render(pOptions.htmlID);
            if (this.options.tabOpen != 'none'){
                //$("#" + lx.comment.options.htmlID).find("ul.t-Tabs > li.SR_lxCommentsTab"+ self.options.tabOpen +"_tab > a").trigger("click");
                this.fetchComments(this.options.htmlID);
            }
        } else {
            this.options = pOptions;
            if(!pOptions.tabOpen) pOptions.tabOpen = 'first';
            this.setAttributes(pOptions.htmlID);
            this.fetchComments(pOptions.htmlID);
        }
    },
    initAll: function(){
        var self = lx.comment;
        $(".commInit").each(function (){
            self.init({htmlID: this.id, extractOptions: true});
            // remove initialization flag
            $(this).removeClass("commInit");
        });
    },
    findHtmlID: function (pThis){
        var self = lx.comment;
        self.$cont = $(pThis).closest(".lxpComments").parent();
        if (self.$cont.hasClass('lxpDialog__body'))
            self.$cont = self.$cont.closest(".lxpDialog");
        self.options.htmlID = self.$cont.attr("id");
    },
    setOptions: function (pHtmlID){
        var self = lx.comment, temp;
        self.extractOptions = true;
        // options
        self.options.htmlID = pHtmlID;
        self.$cont = $("#"+ self.options.htmlID );
        self.options.recId   = self.$cont.attr("data-recid");
        self.options.etyId   = self.$cont.attr("data-etyid");
        temp = self.$cont.attr("data-notifyid");
        self.options.notifyId = (typeof temp == undefined || temp == "" ? null : temp);
        temp = self.$cont.attr("data-fetch");
        self.options.fetch = (typeof temp == undefined || temp == "" ? null : temp);
        temp = self.$cont.attr("data-internal");
        self.data.internal = (typeof temp == undefined || temp == "" ? 0 : temp);
        temp = self.$cont.attr("data-shared");
        self.data.shared = (typeof temp == undefined || temp == "" ? 0 : temp);
        temp = self.$cont.attr("data-updates");
        self.data.updates  = (typeof temp == undefined || temp == "" ? 0 : temp);
        temp = self.$cont.attr("data-internalcnt");
        self.data.internalCnt = (typeof temp == undefined || temp == "" ? 0 : temp);
        temp = self.$cont.attr("data-sharedcnt");
        self.data.sharedCnt = (typeof temp == undefined || temp == "" ? 0 : temp);
        temp = self.$cont.attr("data-updatescnt");
        self.data.updatesCnt  = (typeof temp == undefined || temp == "" ? 0 : temp);
        temp = self.$cont.attr("data-tabopen");
        self.options.tabOpen  = (typeof temp == undefined || temp == "" ? "first" : temp);
        temp = self.$cont.attr("data-bookmarkcnt");
        self.data.bookmarkCnt = (typeof temp == undefined || temp == "" ? 0 : temp);
        temp = self.$cont.attr("data-ownbookmarkCnt");
        self.data.ownbookmarkCnt = (typeof temp == undefined || temp == "" ? 0 : temp);
        temp = self.$cont.attr("data-likescnt");
        self.data.likesCnt = (typeof temp == undefined || temp == "" ? 0 : temp);
        temp = self.$cont.attr("data-ownlikecnt");
        self.data.ownlikeCnt = (typeof temp == undefined || temp == "" ? 0 : temp);
    },
    setAttributes: function (pHtmlID) {
        var self = lx.comment;
        self.$cont = $("#"+ pHtmlID);
        // set parameters as attributes
        self.$cont.attr("data-recid", self.options.recId);
        self.$cont.attr("data-etyid", self.options.etyId);
        self.$cont.attr("data-notifyid", self.options.notifyId);
        self.$cont.attr("data-internal", self.data.internal);
        self.$cont.attr("data-shared", self.data.shared);
        self.$cont.attr("data-updates", self.data.updates);
        self.$cont.attr("data-internalcnt", self.data.internalCnt);
        self.$cont.attr("data-sharedcnt", self.data.sharedCnt);
        self.$cont.attr("data-updatescnt", self.data.updatesCnt);
        self.$cont.attr("data-tabopen", self.options.tabOpen);
        self.$cont.attr("data-bookmarkCnt", self.data.bookmarkCnt);
        self.$cont.attr("data-ownbookmarkCnt", self.data.ownbookmarkCnt);
        self.$cont.attr("data-likesCnt", self.data.likesCnt);
        self.$cont.attr("data-ownlikeCnt", self.data.ownlikeCnt);
    },
    fetchComments: function(pHtmlID) {
        var self = lx.comment;
		// Martin, 11.02.2025., adding 'if' for uploads in feed comments
		// fetch options data if diferent container ID
		if (typeof pHtmlID !== "undefined" && self.options.htmlID != pHtmlID){
                    self.setOptions(pHtmlID, true);
           }
        lx.load.add();
        apex.server.process("getCommJSON", {
            x01: self.options.recId,
            x02: self.options.etyId,
            x03: (typeof self.user === "undefined" ? 1 : 0),//self.options.shared,
            x04: self.options.notifyId,
            x05: self.data.updates
        }, {
            dataType: "json",
            success: function(pData) {
                lx.load.remove();
                self.data = pData.data;
                if (typeof pData.loc !== 'undefined') self.loc = pData.loc;
                if (typeof pData.user !== 'undefined') self.user = pData.user;
                //self.data = pData;
                //self.options.shared = self.data.shared;
                //self.shared = self.data.shared;
				
                // fetch options data if diferent container ID
                if (typeof pHtmlID !== "undefined" && self.options.htmlID != pHtmlID){
                    self.setOptions(pHtmlID, true);
                }
				
                self.$cont.attr("data-fetch","0");
                self.render(pHtmlID);
            }
        });
    },
    fetchUpdates: function(pThis, pRefresh) {
        var self = lx.comment;
        var $btn = $(pThis);
        self.findHtmlID(pThis);
        var vEtyId = self.$cont.attr("data-etyid");
        var vRecId = self.$cont.attr("data-recid");
        var vNotifyId = self.$cont.attr("data-notifyid");
        var $container = $btn.closest(".lxpComments").find(".SR_lxCommentsTabUpdates");
        var vStart = 0;
        var vFetch = false;
        if ($container.find(".lxpComment").length == 0 || pRefresh) vFetch = true;
        if (vFetch) {
            if ($btn.hasClass("commentShowMore")) vStart = $btn.attr("startat");
            lx.load.add();
            apex.server.process("getFeedPostUpdates", {
                x01: vEtyId,
                x02: vRecId,
                x03: vStart,
                x04: vNotifyId
            }, {
                dataType: "html",
                success: function(d) {
                    lx.load.remove();
                    if (vStart == 0) {
                        $container.html(d);
                    } else {
                        $btn.replaceWith(d);
                    }
                }
            });
        }
    },
    changeTab: function(pThis) {
        var self = lx.comment;
        // handle tab elements
        var $this = $(pThis);
        var tabId = $this.closest('li').attr("aria-controls");
        var tabIdentifier = tabId.substr(16);
        // find top ID
        self.findHtmlID(pThis);
        if (tabIdentifier != "Updates" && self.$cont.attr("data-fetch") == "1"){
            self.setOptions(self.options.htmlID);
            this.fetchComments(self.options.htmlID);
        }
        // post textbox placeholder
        var $postForm = $(pThis).closest(".lxpComments").find(".postForm");
        // unselect
        var closeTab = $this.closest('ul').find('li.a-Tabs-selected').attr("aria-controls") === tabId;
        $this.closest('ul').find('li.a-Tabs-selected').removeClass('a-Tabs-selected is-active');
        $this.closest('div').find('.a-Tabs-panel.a-Tabs-element-selected').removeClass('a-Tabs-element-selected').attr('aria-hidden', 'false').css('display', 'none');
        if (closeTab) {
            self.options.tabOpen = 'none';
            $('#'+ self.options.htmlID).attr("data-tabopen", self.options.tabOpen);
            $postForm.hide();
            return;
        }
        // set opened tab attr
        self.options.tabOpen = tabIdentifier;
        $('#'+ self.options.htmlID).attr("data-tabopen", self.options.tabOpen);
        // select
        $this.closest('li').addClass('a-Tabs-selected is-active');
        $this.closest('div').find('.' + tabId).addClass('a-Tabs-element-selected').css('display', '').attr('aria-hidden', 'true');
        // post form
        $postForm.find('.note').hide();
        if      (self.options.tabOpen == 'Shared')   {
            $postForm.show().find('textarea').attr('placeholder', self.loc.SHARED_CMT_PH);
            $postForm.find('.note-'+ self.options.tabOpen).show();
            if (self.options.etyId == 77 || self.options.etyId == 96) {
				$postForm.find(".commUploadBtn").show();	
			} else {
				$postForm.find(".commUploadBtn").hide();
			}
        } else if (self.options.tabOpen == 'Internal') {
            $postForm.show().find('textarea').attr('placeholder', self.loc.INTERNAL_CMT_PH);
            $postForm.find('.note-'+ self.options.tabOpen).show();
            /*$postForm.find(".commUploadBtn").show();*/
            if (self.options.etyId == 77 || self.options.etyId == 96) {
				$postForm.find(".commUploadBtn").hide();	
			} else {
				$postForm.find(".commUploadBtn").show();
			}
        } else if (self.options.tabOpen == 'Updates')  $postForm.hide();
        // feed updates tab
        if (tabId == "SR_lxCommentsTabUpdates") self.fetchUpdates(pThis);
    },
    render: function(pHtmlID) {
        var self = lx.comment;
        var html = '';
        var tabInternal = '',
            tabShared = '';
        // shared and internal comm row rendering
        if (self.data.row.length > 0){
            self.data.internalCnt = 0;
            self.data.sharedCnt = 0;
            for (var i = 0; i < self.data.row.length; i++) {
                if (self.data.row[i].shareCmt) {
                    tabShared += self.renderRow(self.data.row[i], self);
                    self.data.sharedCnt++;
                } else {
                    tabInternal += self.renderRow(self.data.row[i], self);
                    self.data.internalCnt++;
                }
            }
        }
        // determine active tab
        if (self.options.tabOpen == 'first') {
            self.options.tabOpen = ( self.data.internal == 1 ? 'Internal' :
                                    ( self.data.shared   == 1 ? 'Shared' :
                                    (self.data.updates  == 1 ? 'Updates' : 'first')));
            self.$cont.attr("data-tabopen", self.options.tabOpen);
        }
        /*self.options.tabOpen = (self.options.tabOpen == 'first' || typeof self.options.tabOpen == "undefined" ?
                                (self.data.shared   == 1 ? 'Shared' :
                                (self.data.internal == 1 ? 'Internal' : 
                                (self.data.updates  == 1 ? 'Updates' : self.options.tabOpen))) : self.options.tabOpen);
        self.$cont.attr("data-tabopen", self.options.tabOpen);*/
        // tab html
        function getTab(pLabel, pIdentifier, pNote, pNoteType){
            //if (typeof pLabel !== "undefined") {
                var tabRows = "";
                var tabRowCnt = 0;
				var tabOwnRowCnt = 0;
                var tabLikeRowCnt = 0;
				var tabOwnLikeRowCnt = 0;
                switch (pIdentifier){
                    case "Shared":
                        tabRows = tabShared;
                        tabRowCnt = self.data.sharedCnt;
                        break;
                    case "Internal":
                        tabRows = tabInternal;
                        tabRowCnt = self.data.internalCnt;
                        break;
                    case "Updates":
                        tabRowCnt = self.data.updatesCnt;
                        break;
                    case "Bookmark":
                        tabRowCnt = self.data.bookmarkCnt;
                        tabOwnRowCnt = self.data.ownbookmarkCnt;
                        tabLikeRowCnt = self.data.likesCnt;
                        tabOwnLikeRowCnt = self.data.ownlikeCnt;
                        break;
                }
                if (typeof tabRowCnt == "undefined") tabRowCnt = 0;
				if (typeof tabOwnRowCnt == "undefined") tabOwnRowCnt = 0;
                if (typeof tabLikeRowCnt == "undefined") tabLikeRowCnt = 0;
				if (typeof tabOwnLikeRowCnt == "undefined") tabOwnLikeRowCnt = 0;
                // tab content
                tabs += '<div data-label="' + pLabel + '" role="tabpanel" class="a-Tabs-panel SR_lxCommentsTab'+ pIdentifier +
                    (pIdentifier == self.options.tabOpen ? ' a-Tabs-element-selected' : '" style="display: none;')+
                    '" aria-labelledby="SR_lxCommentsTab'+ pIdentifier +'_tab" aria-hidden="false" data-tab="'+ pIdentifier +'">' +
                    tabRows +
                    '</div>';
                // tab Note
                if (typeof pNote !== "undefined")
                    tabNotes += '<div class="note note-'+ pIdentifier + (self.options.tabOpen == pIdentifier ? "": '" style="display:none;') +'">' + pNote + '</div>';
                // tab Controls
				if (pIdentifier !== 'Bookmark') {
					tabBtns += '<li class="t-Tabs-item SR_lxCommentsTab'+ pIdentifier +'_tab'+ (self.options.tabOpen == pIdentifier ? ' a-Tabs-selected is-active' : "")+
					'" aria-controls="SR_lxCommentsTab'+ pIdentifier +'" role="presentation" >' + //style="width:50%;"
					'<a href="javascript:void(0);" class="t-Tabs-link"' + (tabRowCnt == 0 ? "" : ' style="color:#333333;font-weight:bold;" ') + 
					  ' role="tab" aria-controls="SR_lxCommentsTab'+ pIdentifier +'" onclick="lx.comment.changeTab(this)"'+
					(pIdentifier == 'Updates' ? ' data-recid="'+ self.options.recId +'" data-etyid="'+ self.options.etyId +'"' : "" ) +
					'><span>' + (/*self.options.etyId == 55 && */pIdentifier == 'Internal' ? lx.tran.get('ADMIN_COMMENTS') : pLabel) + '</span> (<span class="badge">'+ tabRowCnt +'</span>)</a></li>';
				} else {
					var btnType = "'ARTICLE'";
					var btnReaction = "'B'";
					/*tabBtns += '<li class="t-Tabs-item SR_lxCommentsTab'+ pIdentifier +'_tab'+ (self.options.tabOpen == pIdentifier ? ' a-Tabs-selected is-active' : "")+
					'" aria-controls="SR_lxCommentsTab'+ pIdentifier +'" role="presentation" >' +
					'<div class="t-Tabs-link reaction"' + (tabRowCnt == 0 ? "" : ' style="" ') + 
					' role="tab" aria-controls="SR_lxCommentsTab'+ pIdentifier +'" ' +
					(pIdentifier == 'Updates' ? ' data-recid="'+ self.options.recId +'" data-etyid="'+ self.options.etyId +'"' : "" ) +
					'><span class="art-reaction" onclick="' +
					(tabOwnLikeRowCnt == 0 ? 'lx.bookmark.add('+ self.options.etyId + ',' + self.options.recId + ',' + btnType + ',this,' + "'L'" +')"' : 'lx.bookmark.remove('+ self.options.etyId + ',' + self.options.recId + ',' + btnType + ',this,' + "'L'" +')"') +
					'><span>' + (tabOwnLikeRowCnt == 0 ? '<i class="far fawe-thumbs-up lxBookmarkIcon">' : '<i class="fas fawe-thumbs-up lxBookmarkIconFullL">') + '</i></span><span class="badge"> '+ tabLikeRowCnt +'</span></span>' +
					'<span class="art-reaction" onclick="' +
					(tabOwnRowCnt == 0 ? 'lx.bookmark.add('+ self.options.etyId + ',' + self.options.recId + ',' + btnType + ',this,' + "'B'" +')"' : 'lx.bookmark.remove('+ self.options.etyId + ',' + self.options.recId + ',' + btnType + ',this,' + "'B'" +')"') +
					'><span>' + (tabOwnRowCnt == 0 ? '<i class="far fawe-bookmark lxBookmarkIcon">' : '<i class="fas fawe-bookmark lxBookmarkIconFullB">') + '</i></span><span class="badge"> '+ tabRowCnt +'</span></span>' +
					'</div></li>';*/
					
					tabBtns += '<li class="t-Tabs-item SR_lxCommentsTab'+ pIdentifier +'_tab'+ (self.options.tabOpen == pIdentifier ? ' a-Tabs-selected is-active' : "")+
					'" aria-controls="SR_lxCommentsTab'+ pIdentifier +'" role="presentation" style="flex-shrink: 0;flex-basis: 64px;flex-grow: 0;">' +
					'<div class="t-Tabs-link reaction"' + (tabRowCnt == 0 ? "" : ' style="" ') + 
					' role="tab" aria-controls="SR_lxCommentsTab'+ pIdentifier +'" ' +
					(pIdentifier == 'Updates' ? ' data-recid="'+ self.options.recId +'" data-etyid="'+ self.options.etyId +'"' : "" ) +
					'><span class="art-reaction" onclick="' +
					(tabOwnLikeRowCnt == 0 ? 'lx.bookmark.add('+ self.options.etyId + ',' + self.options.recId + ',' + btnType + ',this,' + "'L'" +')"' : 'lx.bookmark.remove('+ self.options.etyId + ',' + self.options.recId + ',' + btnType + ',this,' + "'L'" +')"') +
					'><span>' + (tabOwnLikeRowCnt == 0 ? '<i class="far fawe-thumbs-up lxBookmarkIcon">' : '<i class="fas fawe-thumbs-up lxBookmarkIconFullL" style="'+ self.data.iconStyle +'">') + '</i></span><span class="badge"> '+ tabLikeRowCnt +'</span></span>'+
					'</div></li>';
					
					tabBtns += '<li class="t-Tabs-item SR_lxCommentsTab'+ pIdentifier +'_tab'+ (self.options.tabOpen == pIdentifier ? ' a-Tabs-selected is-active' : "")+
					'" aria-controls="SR_lxCommentsTab'+ pIdentifier +'" role="presentation" style="flex-shrink: 0;flex-basis: 64px;flex-grow: 0;">' +
					'<div class="t-Tabs-link reaction"' + (tabRowCnt == 0 ? "" : ' style="" ') + 
					' role="tab" aria-controls="SR_lxCommentsTab'+ pIdentifier +'" ' +
					(pIdentifier == 'Updates' ? ' data-recid="'+ self.options.recId +'" data-etyid="'+ self.options.etyId +'"' : "" ) +
					'><span class="art-reaction" onclick="' +
					(tabOwnRowCnt == 0 ? 'lx.bookmark.add('+ self.options.etyId + ',' + self.options.recId + ',' + btnType + ',this,' + "'B'" +')"' : 'lx.bookmark.remove('+ self.options.etyId + ',' + self.options.recId + ',' + btnType + ',this,' + "'B'" +')"') +
					'><span>' + (tabOwnRowCnt == 0 ? '<i class="far fawe-bookmark lxBookmarkIcon">' : '<i class="fas fawe-bookmark lxBookmarkIconFullB">') + '</i></span><span class="badge"> '+ tabRowCnt +'</span></span>' +
					'</div></li>';
				}
        }
        var tabs = "";
        var tabBtns = "";
        var tabNotes = "";
        if (self.options.etyId == 1 || self.options.etyId == 2 || self.options.etyId == 3 || self.options.etyId == 4) { getTab(self.loc.BOOKMARK, 'Bookmark')};
        if (self.data.internal == 1) getTab(self.loc.INTERNAL_CMT_LABEL, 'Internal', self.loc.INTERNAL_CMT_NOTE, 'info');
        if (self.data.shared == 1) getTab(self.loc.SHARED_CMT_LABEL, 'Shared', self.loc.SHARED_CMT_NOTE, 'warning');
        if (self.data.updates == 1) getTab(self.loc.UPDATES, 'Updates');
        tabBtns = '<ul class="t-Tabs t-Tabs--fillLabels t-Tabs--pill t-Tabs--large a-Tabs" role="tablist">'+ tabBtns +'</ul>';

        var form = "";
		if (self.loc.UPLOAD == 'OFF' && self.loc.POST == 'OFF') {
			form = '<div class="postForm"'+ (self.options.tabOpen == 'Updates' || self.options.tabOpen == 'none' ? ' style="display:none"' : '') +'>'+
							'<textarea maxlength="4000" class="textarea apex-item-textarea" placeholder="' + 
							(self.options.tabOpen == 'Shared' ? self.loc.SHARED_CMT_PH : self.loc.INTERNAL_CMT_PH) + '"></textarea>' +
							'<div style="display:flex;justify-content: flex-end;align-items: flex-start;">' +
							tabNotes +
							'</div>'+
						'</div>';
		}else {	
			form = '<div class="postForm"'+ (self.options.tabOpen == 'Updates' || self.options.tabOpen == 'none' ? ' style="display:none"' : '') +'>'+
							'<textarea maxlength="4000" class="textarea apex-item-textarea" placeholder="' + 
							(self.options.tabOpen == 'Shared' ? self.loc.SHARED_CMT_PH : self.loc.INTERNAL_CMT_PH) + '"></textarea>' +
							'<div style="display:flex;justify-content: flex-end;align-items: flex-start;">' +
							tabNotes +
							// upload link
							(self.data.uploadLink == '#' ? '': lx.btn.gen({ label: self.loc.UPLOAD,
																			link: self.data.uploadLink,
																			fa: 'far fawe-paperclip',
																			class: 'commUploadBtn'+ ((self.options.etyId == 77 || self.options.etyId == 96) ? (self.options.tabOpen == "Internal" ? " lxHidden" : "") : (self.options.tabOpen == "Internal" ? "" : " lxHidden")) })) +
																			/*(self.options.tabOpen == "Internal" ? "" : " lxHidden")*/ 
							// post link
							lx.btn.gen({label: self.loc.POST,
										js: 'lx.comment.submit(this)',
										fa: 'far fawe-paper-plane',
										class: self.data.btnClass, /*'t-Button--primary',*/
										style: self.data.btnStyle}) +
										//class: 't-Button t-Button--icon t-Button--medium t-Button--primary t-Button--iconLeft commUploadBtn'}) +
							'</div>'+
						'</div>';
		}	
					
					
        html = '<div class="lxpComments">' +
                '<div class="comments">' + 
                    tabBtns + 
                    form +
                    tabs  +
                '</div>'+
               '</div>';

        if (self.options.htmlID == "lxpDialog_comments") $("#" + lx.comment.options.htmlID +" .lxpDialog__body").html(html);
        else if (lx.comment.options.htmlID) $("#" + lx.comment.options.htmlID).html(html);
        else {
            /*lx.dialog.open({id: "comments", 
                            html: html,
                            //title: 'Comments',
                            maxWidth: "639px"
                        });*/
            lx.drawer.open('',html, false, "comments", 'sm');
            self.options.htmlID = "lxpDialog_comments";
            self.setAttributes(self.options.htmlID);
        }
    },
    renderRow: function(row, self) {
        var lRet = '<div class="lxpComment" recid="' + row.id + '">' + row.plink +
		    lx.profile.genPic(row.img) +
            '</a><div class="commRow">'+
            '<div class="hdr"><b>' + row.name + '</b>' + (row.behalf ? row.behalf : '') +'</div>'+
            '<div class="body">' + 
                (row.deleted ? '<span class="deleted">'+ (row.attach ? self.loc.DELETED_ATTACH : self.loc.DELETED_CMT) +'</span>' :
                                (row.post ? linkifyHtml(row.post, {target: '_blank'}) : '')) + 
            '</div>' +
            '<div class="ftr"><span class="time">' + (row.updated ? self.loc.EDITED +' '+ row.updated : row.time) +'</span>'+
            (row.attach ? '' :  (row.edit ? ' &bull; <span class="editLink" onclick="lx.comment.edit(this);">' + self.loc.EDIT + '</span>' : '') +
                                (!row.deleted && (row.edit || self.data.deleteAll) ? ' &bull; <span class="editLink" onclick="lx.comment.delete(this);">' + self.loc.DELETE + '</span>' : '')) +
            '</div>' +
            '</div>'+
            '</div>';
		
        return lRet;
    },
    submit: function(pThis) {
        var self = lx.comment;
        var $postItem = $(pThis).closest(".postForm").find("textarea");
        // get comment text
        var lPost = $postItem.val();
        // find top ID (which holds the options in data attributes)
        self.findHtmlID(pThis);
        // set options from data atributes
        self.setOptions(self.options.htmlID);
        // reset textarea
        $postItem.val("");
        // comment row json
        var row = {
            id: 0,
            img: self.user.img,
            name: self.user.name,
            behalf: self.user.behalf,
            time: self.loc.NOW,
            post: lPost,
			plink: self.user.plink,
            shared: (self.options.tabOpen == 'Shared' ? 1 : 0)
        };
        // call AJAX process
        lx.load.add();
        apex.server.process("handleComment", {
            x01: self.options.recId,
            x02: self.options.etyId,
            x03: row.post,
            x04: row.shared, //self.options.shared,
            x05: self.options.caller
        }, {
            dataType: "json",
            success: function(pData) {
                lx.load.remove();
                if (pData.processed) {
                    row.id = pData.id;
                    row.time = pData.time;
                    // determine comment rows tab
                    var tabId = (row.shared == 1 ? 'Shared' : 'Internal');
                    //append submited comment
                    $(pThis).closest(".lxpComments").find(".SR_lxCommentsTab" + tabId).prepend(self.renderRow(row, self));
                    // increase comment cnt
                    var $cntBadge = $(pThis).closest(".lxpComments").find(".SR_lxCommentsTab" + tabId +"_tab .badge");
                    $cntBadge.text( parseInt($cntBadge.text()) + 1 );
                    /*if (row.shared == 1) {
                        self.data.sharedCnt++;
                        $(pThis).closest(".lxpComments").find(".SR_lxCommentsTab" + tabId +"_tab .badge").text(self.data.sharedCnt);
                    } else {
                        self.data.internalCnt++;
                        $(pThis).closest(".lxpComments").find(".SR_lxCommentsTab" + tabId +"_tab .badge").text(self.data.internalCnt);
                    }*/
                    // refresh row
                    if ($v("pFlowStepId") == 325)
                        lxTaskList($v("P325_PROJECT_ID"), self.options.recId);
                    else if (pData.refresh) { 
                        let $btn = $("#Comm"+ self.options.recId);
                        if ($btn.hasClass('t-Button')) {
                            //if (!$btn.hasClass('t-Button--hot') && pData.refresh.comm > 0) $btn.addClass('t-Button--hot');
                            //else if (pData.refresh.comm == 0) $btn.removeClass('t-Button--hot');
                            $btn.find('span').text(function(_, current) {
                                return current.replace(/\s*\(\d+\)$/, '') + ' (' + pData.refresh.comm + ')';
                                //(current.includes("|") ? current.replace(/\d+$/, pData.refresh.comm) : current +' | '+ pData.refresh.comm);
                            });
                        } else {
                            $("#Comm"+ self.options.recId).removeClass();
                            $("#Comm"+ self.options.recId).addClass('temp');
                            $("#Comm"+ self.options.recId+ ">i").removeClass();
                            $("#Comm"+ self.options.recId+ ">i").addClass('fas fawe-comment-alt-lines');
                            lx.ir.refreshRow(self.options.caller, self.options.recId, pData.refresh);
                        }
                    } else if (self.options.etyId == 32 && self.page != 1) {
                        lxpGantt.getTaskAjax(self.options.recId,true);
                    }

                } else {
                    alert(pData.err);
                }
            }
        });
    },
    edit: function(pThis) {
        var self = lx.comment;
        var $rec = $(pThis).closest(".lxpComment");
        var commID = $rec.attr("recid");
        if ($(pThis).hasClass("editLink")) {
            var $post = $rec.find(".body");
            $post.html('<div class="editForm"><textarea maxlength="4000">' + $post.text() + '</textarea>' +
                lx.btn.gen({
                    label: self.loc.POST,
                    js: 'lx.comment.edit(this)',
                    fa: 'far fawe-paper-plane',
                    class: 't-Button--primary'
                }) +
                '</div>');
        } else {
            var newPost = $rec.find("textarea").val();
            lx.load.add();
            apex.server.process("handleComment", {
                x01: commID,
                x02: 0,
                x03: newPost,
                x05: self.options.caller
            }, {
                dataType: "json",
                success: function(pData) {
                    lx.load.remove();
                    if (pData.processed) {
                        //self.data.row[self.getRowIdx(commID, self.data.row)].post = newPost;
                        $rec.find(".body").html(apex.util.escapeHTML(newPost));
                        $rec.find(".time").text(self.loc.EDITED +" "+ self.loc.NOW );
                    } else {
                        alert(pData.err);
                    }
                }
            });
        }
    },
    delete: function(pThis) {
        var self = lx.comment;
        var $rec = $(pThis).closest(".lxpComment");
        var commID = $rec.attr("recid");
        lx.load.add();
        apex.server.process("handleComment", {
            x01: commID,
            x02: -1,
            x05: self.options.caller
        }, {
            dataType: "json",
            success: function(pData) {
                lx.load.remove();
                if (pData.processed) {
                    //self.data.row.splice(self.getRowIdx(commID, self.data.row), 1);
                    /*if (self.options.shared == 1) self.data.sharedCnt--;
                    else {
                        self.data.internalCnt--;
                        $("#internalCnt").text(self.data.internalCnt);
                    }*/
					if (pData.shared == 'Y') {
						var tabId = $(pThis).closest(".a-Tabs-panel").attr("data-tab");
						var $cntBadge = $(pThis).closest(".lxpComments").find(".SR_lxCommentsTab" + tabId +"_tab .badge");
						$cntBadge.text( parseInt($cntBadge.text()) - 1 );
						$rec.hide();
					}
                    else {
						var tabId = $(pThis).closest(".a-Tabs-panel").attr("data-tab");
						var $cntBadge = $(pThis).closest(".lxpComments").find(".SR_lxCommentsTab" + tabId +"_tab .badge");
						$cntBadge.text( parseInt($cntBadge.text()) - 1 );

						if (pData.refresh) {
							lx.ir.refreshRow(self.options.caller, self.options.recId, pData.refresh);
						}
						$rec.find(".body").html( '<span class="deletedT">'+ self.loc.DELETED_CMT +'</div>');
						$rec.find(".editLink").remove();
					}					
                } else {
                    alert(pData.err);
                }
            }
        });
    }
};

lx.comment.feed = lx.comment.feed || {};
lx.comment.feed.post = function(pEtyId, pRecId, pThis, e, pShare) {
    var vInput, vFilterId;

    function postComments() {
        if ($(pThis).closest(".feed-post").find(".uiFeedShared").hasClass("uiSelected")) {
            var lShare = 'Y';
        } else {
            var lShare = '';
        }
        $.ajax({
            url: "wwv_flow.show",
            dataType: "html",
            traditional: true,
            cache: false,
            type: "POST",
            data: {
                p_flow_id: $v("pFlowId"),
                p_flow_step_id: $v("pFlowStepId"),
                p_instance: $v("pInstance"),
                p_request: 'APPLICATION_PROCESS=SAVE_COMMENTS',
                x01: pRecId,
                x02: pEtyId,
                x03: $(vInput).val(),
                x04: vFilterId,
                x07: lShare
            },
            success: function(d) {
                if (d == 'NOK') {
                    raiseError(apex.lang.getMessage("JS13"));
                } else {
                    $(pThis).val('');
                    if (pShare == '') {
                        feedNewCommentInt(pThis);
                    } else {
                        feedNewComment(pThis);
                    }
                    getFeedComments(pEtyId, pRecId, vInput, true, vFilterId, lShare);
                }
            }
        })
    }

    function raiseError(p) {
        var lErr = $nvl(p, apex.lang.getMessage("JS14"));
        $("#htmlcmt_post").addClass('ui-state-error ui-corner-all fielddatabold');
        alert(lErr);
    }
    vFilterId = $(pThis).siblings(".feed_com-filter_id").val();
    if ($(pThis).hasClass("m-btn")) {
        vInput = $(pThis).siblings("textarea");
        postComments();
    } else if (e.keyCode == 13 && e.shiftKey) {
        e.stopImmediatePropagation();
        vInput = $(pThis);
        postComments();
    }
};

/* DEPRICATED 19.1.2021 by Davor */
lx.comment.feed.get = function(pEtyId, pRecId, pThis, pRefresh, pFilterId, pShare) {
    var $container = $(pThis).closest(".feed-content").find(".feed-post_comments");
    var vStart = 0;
    var vVisible = false;
    if ($container.is(":visible")) vVisible = true;
    var vFetch = true;
    //if ($container.find(".uiComments").length == 0 || pRefresh) vFetch = true;

    if (vFetch) {
        if ($(pThis).parent().hasClass("feed-comment_post_more")) vStart = $(pThis).attr("startat");
        $.ajax({
            url: "wwv_flow.show",
            dataType: "html",
            traditional: true,
            cache: false,
            type: "POST",
            data: {
                p_flow_id: $v("pFlowId"),
                p_flow_step_id: $v("pFlowStepId"),
                p_instance: $v("pInstance"),
                p_request: "APPLICATION_PROCESS=getComments",
                x01: pRecId,
                x02: pEtyId,
                x03: 'FEED',
                x04: vStart,
                x05: pFilterId,
                x06: pShare
            },
            success: function(d) {
                if (vStart == 0) {
                    $container.html(d);
                } else {
                    $container.find("table.feed-comment_posts > tbody tr:first").replaceWith(d);
                }
            }
        });
        if (!vVisible) $container.animate({
            height: "toggle"
        }, {
            duration: 300,
            specialEasing: {
                height: "easeInQuad"
            }
        });
        if (!pRefresh) {
            $(pThis).closest(".feed-post").find(".uiSelected").css("background-color", "#eeeeee;");
            $(pThis).closest(".feed-post").find(".uiSelected").removeClass("uiSelected");
            $(pThis).addClass("uiSelected");
            if ($(pThis).closest(".feed-post").find(".uiFeedShared").hasClass("uiSelected")) {
                $(pThis).closest(".feed-post").find(".uiSelected").css("background-color", "#f5d8d9;");
            } else if ($(pThis).closest(".feed-post").find(".uiFeedInternal").hasClass("uiSelected")) {
                $(pThis).closest(".feed-post").find(".uiSelected").css("background-color", "#c3e0dc;");
            } else if ($(pThis).closest(".feed-post").find(".uiFeedUpdate").hasClass("uiSelected")) {
                $(pThis).closest(".feed-post").find(".uiSelected").css("background-color", "#e2e2e2;");
            } else if ($(pThis).closest(".feed-post").find(".feed-comment_cnt-btn").hasClass("uiSelected")) {
                $(pThis).closest(".feed-post").find(".uiSelected").css("background-color", "#e2e2e2;");
                $(pThis).closest(".feed-post").find(".printicon").css("background-color", "#e2e2e2;");
            } else if ($(pThis).closest(".feed-post").find(".printicon").hasClass("uiSelected")) {
                $(pThis).closest(".feed-post").find(".uiSelected").css("background-color", "#e2e2e2;");
            }

            $(pThis).closest(".feed-post").find(".htmlcmt_post").focus();
        }
    } else {
        $container.animate({
            height: "toggle"
        }, {
            duration: 300,
            specialEasing: {
                height: "easeInQuad"
            }
        });
        $container.html("");
        $(pThis).removeClass("feed-comment_cnt-selected");
    }
};
/* DEPRICATED 19.1.2021 by Davor */
lx.commentOld.timers = function() {
    var gRetSecs = null,
        gRetIds = null;
    var lRecId = $v("P" + $v("pFlowStepId") + "_ID");
    var lEtyId = $v("P" + $v("pFlowStepId") + "_ENTITY_ID");

    lx.load.add();
    apex.server.process("getCommentSecsArray", {
        x01: lRecId,
        x02: lEtyId
    }, {
        dataType: 'text',
        success: function(pData) {
            gRetSecs = pData;
            apex.server.process("getCommentIdsArray", {
                x01: lRecId,
                x02: lEtyId
            }, {
                dataType: 'text',
                success: function(pData2) {
                    gRetIds = pData2;
                    lx.load.remove();

                    if (gRetIds !== null) {
                        var arraySecs = gRetSecs.split(',');
                        var arrayIds = gRetIds.split(',');
                        for (var i = 0; i < arrayIds.length; i++) {
                            //alert("setTimeout(function() {$('#commentEdit" + arrayIds[i] + "').fadeOut('fast');}," + arraySecs[i] + ");");
                            window.onload = function() {
                                setTimeout(function() {
                                    document.getElementById('commentEdit' + arrayIds[i]).fadeOut('fast');
                                }, 5000);
                            };
                            window.onload = function() {
                                setTimeout(function() {
                                    document.getElementById('commentDelete' + arrayIds[i]).fadeOut('fast');
                                }, 5000);
                            };
                        }
                    }
                }
            });
        }
    });
};
/* DEPRICATED 19.1.2021 by Davor */
lx.commentOld.comment = function(pSize, pMaxLength, pRecId, pEtyId, pIusId, pDocCode, pShare) {
    var lRecId = $nvl(pRecId, $v("P" + $v("pFlowStepId") + "_ID"));
    var lEtyId = $nvl(pEtyId, $v("P" + $v("pFlowStepId") + "_ENTITY_ID"));
    var lIusId = $nvl(pIusId, $v("P" + $v("pFlowStepId") + "_IUS_ID"));
    var lDocCode = $nvl(pDocCode, $v("P" + $v("pFlowStepId") + "_DOC_CODE"));


    if (lEtyId == '') {
        lEtyId = $nvl(pEtyId, $v("P" + $v("pFlowStepId") + "_E"));
    };

    $("#htmlcmt_post").keypress(function(e) {
        if (e.keyCode == 13 && e.shiftKey) {
            e.stopImmediatePropagation();
            postComments();
        }
    });

    $("#uiUseEnterBTN").click(function(e) {
        e.stopImmediatePropagation();
        postComments();
    });

    getComments(pShare);

    function postComments() {
        if ($("#CommShared").hasClass("uiSelected")) {
            var lShare = 'Y';
        } else {
            var lShare = '';
        }

        $.ajax({
            url: "wwv_flow.show",
            dataType: "html",
            traditional: true,
            cache: false,
            type: "POST",
            data: {
                p_flow_id: $v("pFlowId"),
                p_flow_step_id: $v("pFlowStepId"),
                p_instance: $v("pInstance"),
                p_request: 'APPLICATION_PROCESS=SAVE_COMMENTS',
                x01: lRecId,
                x02: lEtyId,
                x03: $v("htmlcmt_post") /*$("#htmlcmt_post").val().replace(/\n/g, "&#10;")*/ ,
                x05: lIusId,
                x06: lDocCode,
                x07: lShare
            },
            success: function(d) {
                if (d == 'NOK') {
                    alert('GreÅ¡ka');
                    raiseError(apex.lang.getMessage("JS13"));
                } else {
                    getComments(lShare);
                    $("#htmlcmt_post").val('');
                    $('html, body').animate({
                        scrollTop: $("#uiComments").offset().top
                    }, 'slow');
                    if ($v("pFlowStepId") == 222) {
                        refresh();
                    } else if ($v("pFlowStepId") == 227 || $v("pFlowStepId") == 423) {
                        refreshTask(lRecId, true);
                    }
                }
            }
        })
    }

    function refresh(json) {
        var etyId = $v("P222_ENTITY_ID");
        var recId = $v("P222_ID");
        var irCode = $v("P222_IR");
        if (irCode != "N") {
            apex.server.process("getCommIR", {
                x01: recId,
                x02: etyId,
                x03: irCode
            }, {
                dataType: 'json',
                success: function(d) {
                    window.parent.lx.ir.refreshRow(irCode, recId, d);
                }
            });
        } else if (etyId == 5 || etyId == 39 || etyId == 55 || etyId == 38) {
            window.parent.lx.oldir.refresh();
        }
    }

    function raiseError(p) {
        var lErr = $nvl(p, apex.lang.getMessage("JS14"));
        $("#htmlcmt_post").addClass('ui-state-error ui-corner-all fielddatabold');
        alert(lErr);
    }

    function getComments(pShare) {

        if (pShare == 'Y') {
            $("#CommInternal").removeClass('uiSelected');
            $("#CommInternal").css("background-color", "#eeeeee;");
            $("#CommShared").addClass('uiSelected');
            $("#CommShared").css("background-color", "#f5d8d9;");
        } else {
            $("#CommShared").removeClass('uiSelected');
            $("#CommShared").css("background-color", "#eeeeee;")
            $("#CommInternal").addClass('uiSelected');
            $("#CommInternal").css("background-color", "#c3e0dc;");
        }

        $.ajax({
            url: "wwv_flow.show",
            dataType: "html",
            traditional: true,
            cache: false,
            type: "POST",
            data: {
                p_flow_id: $v("pFlowId"),
                p_flow_step_id: $v("pFlowStepId"),
                p_instance: $v("pInstance"),
                p_request: "APPLICATION_PROCESS=getComments",
                x01: lRecId,
                x02: lEtyId,
                x06: pShare
            },
            success: function(d) {
                if (d) {
                    $("#uiCommentSh").html(d);
                }
            }
        });
    }
};
/* DEPRICATED 19.1.2021 by Davor */
lx.commentOld.edit = function(pType, pId) {

    var get = new htmldb_Get(null, $v('pFlowId'), 'APPLICATION_PROCESS=COMMENTS_EDIT', $v('pFlowStepId'));

    /*TO BE APPLIED INSTEAD htmldb_Get function*/
    /*apex.server.process( "COMMENTS_EDIT", {
        x01: pType
	,	x02: pId
    }, {
        dataType: "html",
        sucess: function (d) {
            //add code
        },
        error: function( jqXHR, textStatus, errorThrown ) {
            //add code
        }
    } );*/

    var vTxt;
    if (pType == "D") {
        get.addParam('x01', pType);
        get.addParam('x02', pId);
        ret = get.get('HTML');
        if (ret) {
            alert(ret);
        } else {
            feedNewComment($("#COMMR" + pId), true);
            $("#COMMR" + pId).remove();
            if ($v("pFlowStepId") == 423) setTimeout(function() {
                refreshTask(lxpGantt.comments.taskId, true);
            }, 400);
            else if ($v('pFlowStepId') != 1) lxRefreshTList();
        }
    } else if (pType == "E") {
        //$("#COMM"+pId).css("border","1px solid red");
        vTxt = $("#COMM" + pId).text();
        var field = '<textarea id="E' + pId + '" size="80" maxlength="4000" style="width:99%;">' + vTxt + '</textarea>';
        $("#COMM" + pId).html(field);
        $("#E" + pId).keypress(function(e) {
            if (e.keyCode == 13 && !e.shiftKey) {
                e.preventDefault();
                lx.commentOld.edit('U', pId)
            }
        });
    } else if (pType == "U") {
        vTxt = $v("E" + pId);
        //vTxt = $("#E" + pId).val().replace("&#10;",/\n/g);
        get.addParam('x01', pType);
        get.addParam('x02', pId);
        get.addParam('x03', vTxt);
        ret = get.get('HTML');
        if (ret) {
            alert(ret);
        } else {
            $("#COMM" + pId).html(vTxt);
        }
    } else if (pType == "PR") {

        get.addParam('x01', pType);
        get.addParam('x02', pId);
        ret = get.get('HTML');
        getComments(pId, parseInt(ret));
    } else if (pType == "PU") {

        get.addParam('x01', pType);
        get.addParam('x02', pId);
        ret = get.get('HTML');
        getComments(pId, parseInt(ret));
    }

    function getComments(pRecId, pEtyId) {
        $.ajax({
            url: "wwv_flow.show",
            dataType: "html",
            traditional: true,
            cache: false,
            type: "POST",
            data: {
                p_flow_id: $v("pFlowId"),
                p_flow_step_id: $v("pFlowStepId"),
                p_instance: $v("pInstance"),
                p_request: "APPLICATION_PROCESS=getComments",
                x01: pRecId,
                x02: pEtyId,
                x03: 'PRV'
            },
            success: function(d) {
                if (d) {
                    $("#uiCommentSh").html(d);

                }
            }
        });
    }
};

// TODO cleanup after we ditch the old app
var lxpComments = lx.commentOld.comment;
var lxRefreshTList = lx.commentOld.refresh;
var lxCommentsTimers = lx.commentOld.timers;
var lxCommentEdit = lx.commentOld.edit;
/*var lxpCommentsFeed = lx.comment.feed.set;
var getFeedComments = lx.comment.feed.get;*/